export default "/images/mobile_app_preview.webp"